import axios from "axios";
import { getToken } from "../../utils/auth";

/**
 * Small wrapper around axios used by the administration screens so every call
 * carries the JWT and unwraps `response.data`.
 */
const BASE = process.env.REACT_APP_BASE_URL;

const withAuth = (extra = {}) => ({
  ...extra,
  headers: { Authorization: `Bearer ${getToken()}`, ...(extra.headers || {}) },
});

export const apiGet = (path, params) =>
  axios.get(BASE + path, withAuth({ params })).then((r) => r.data);

export const apiPost = (path, body, params) =>
  axios.post(BASE + path, body, withAuth({ params })).then((r) => r.data);

export const apiPut = (path, body, params) =>
  axios.put(BASE + path, body, withAuth({ params })).then((r) => r.data);

/**
 * Several legacy list endpoints answer 400 / 404 instead of `[]` when the table
 * is empty. Treat those as an empty list so the screens still render.
 */
export const apiGetList = async (path, params) => {
  try {
    const data = await apiGet(path, params);
    return Array.isArray(data) ? data : [];
  } catch (err) {
    const status = err?.response?.status;
    if (status === 400 || status === 404) return [];
    throw err;
  }
};

/** Extracts a human readable message from an axios error. */
export const errorMessage = (err, fallback = "Request failed. Please try again.") => {
  const data = err?.response?.data;
  if (err?.response?.status === 403) {
    // Spring Security answers 403 both for a missing role AND for a route that does not
    // exist on the server (e.g. a backend build without the administration endpoints).
    return `Access denied by the API at ${BASE}. Either your role is not allowed, or that server does not have the administration endpoints deployed yet.`;
  }
  if (err?.response?.status === 401) return "Your session has expired. Please sign in again.";
  if (!err?.response) return `Cannot reach the API at ${BASE}. Is the backend running?`;
  if (!data) return err?.message || fallback;
  if (typeof data === "string") return data;
  if (data.message) return data.message;
  if (data.error) return data.error;
  return fallback;
};

export const toastOpts = { position: "top-center", autoClose: 4000 };
